export const pageNames = {
  start: 'start',
  appeals: 'appeals',
  bdd: 'bdd',
  fileBDD: 'file-bdd',
  unableToFileBDD: 'unable-to-file-bdd',
  fileClaim: 'file-claim',
  fileClaimEarly: 'file-claim-early',
  disagreeFileClaim: 'disagree-file-claim',
};
